import { WellProfileBase } from './base/well-profile-base';

export class WellProfile extends WellProfileBase { }